import React, { useRef } from "react";
import Language from "../lib/Language";

type TUnsupportedCalendarProps = {
    onClose?: () => void;
    size?: React.CSSProperties;
};

const UnsupportedCalendar = (props: TUnsupportedCalendarProps) => {
    const oldSymbol = useRef<string | undefined>(undefined);

    const getOldSymbol = () => {
        if (!oldSymbol.current) {
            const picks = ["📠", "👴", "👵", "🚧"];
            const pick = Math.round(Math.random() * (picks.length - 1));
            oldSymbol.current = picks[pick];
        }
        return oldSymbol.current;
    };
    const tip = Language.get("nc_datechooser_button_tip").split("{0}");
    const closeText = props.onClose ? <p>{Language.get("nc_datechooser_click_to_close")}</p> : null;
    return (
        <div className="calendar" style={props.size} onClick={props.onClose}>
            <div className="oldComponent" style={{ overflow: "auto", cursor: "pointer" }}>
                <div
                    style={{
                        width: "600px",
                        maxWidth: "75%",
                        whiteSpace: "normal",
                    }}
                >
                    <h1>{Language.get("nc_old_calendar_headline")}</h1>
                    <p>{Language.get("nc_datechooser_not_supported")}</p>
                    <p>
                        {tip[0]}
                        <button className="deprecated calendarButton" />
                        {tip[1]}
                    </p>
                    {closeText}
                    <h1>{getOldSymbol()}</h1>
                </div>
            </div>
        </div>
    );
};

export default UnsupportedCalendar;
